import {
  Box,
  Flex,
  Heading,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Text,
} from "monday-ui-react-core";

import { ShortLink } from "@/components/Common";

export function DocumentationPanel() {
  return (
    <>
      <Heading type={Heading.types.h2} value="Resources" style={{ marginTop: 0 }} />
      <Flex direction={Flex.directions.COLUMN} gap={Flex.gaps.SMALL} align={Flex.align.START}>
        <ul style={{ margin: "0" }}>
          <li>
            <Text type={Text.types.TEXT1}>
              For more guidance see the <ShortLink path="monday_documentation">app documentation</ShortLink>.
            </Text>
          </li>
          <li>
            <Text type={Text.types.TEXT1}>
              See what is possible with the list of available <ShortLink path="monday_actions">actions</ShortLink>.
            </Text>
          </li>
          <li>
            <Text type={Text.types.TEXT1}>
              For help and support please see our <ShortLink path="monday_support">customer portal</ShortLink>.
            </Text>
          </li>
        </ul>
      </Flex>
      <Heading type={Heading.types.h2} value="Context Variables" />
      <Flex direction={Flex.directions.COLUMN} gap={Flex.gaps.SMALL} align={Flex.align.START}>
        <Text type={Text.types.TEXT1}>
          There are a number of variables that can be used in commands. These variables comprise the current context for
          each command.
        </Text>
        <Box margin={Box.margins.LARGE}>
          <Table
            columns={[
              { id: "name", title: "Name" },
              { id: "description", title: "Description" },
              { id: "use", title: "Use" },
            ]}
            emptyState={<></>}
            errorState={<></>}
          >
            <TableHeader>
              <TableHeaderCell title="Name" />
              <TableHeaderCell title="Description" />
              <TableHeaderCell title="Use" />
            </TableHeader>
            <TableBody>
              {contextVariables.map((value, i) => (
                <TableRow key={i}>
                  <TableCell>{value.name}</TableCell>
                  <TableCell>{value.description}</TableCell>
                  <TableCell>
                    <code>{value.use}</code>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Flex>
    </>
  );
}

interface ContextVariable {
  description: string;
  name: string;
  use: string;
}

const contextVariables: ContextVariable[] = [
  {
    description: "id of current workspace",
    name: "workspace id",
    use: "{{workspaceId}}",
  },
  {
    description: "id of current board",
    name: "board id",
    use: "{{boardId}",
  },
  {
    description: "id of current user",
    name: "user id",
    use: "{{user.id}",
  },
];
